import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */
export default function Edit() {
  const blockProps = useBlockProps({
    className: 'placeholder wp-block-columns',
  });

  return (
    <div {...blockProps}>
      <div className="wp-block-column" style={{ flexBasis: "50px", alignSelf: "center" }}>
        <span
          className="dashicons dashicons-info-outline"
          style={{ fontSize: "xx-large" }}
        ></span>
      </div>
      <div className="wp-block-column" style={{ flexBasis: "auto", alignSelf: "center" }}>
        <p>Dynamic block for {blockProps['data-title']}</p>
      </div>
    </div>
  );
}
